import Cookies from 'js-cookie';

const SEARCH_COUNT_EXPIRES = 7;
const SEARCH_COUNT_COOKIE_NAME = 'search_count';
const MAX_SEARCH_COUNT = 3;

export const addSearchCountCookie = () => {
  if (Cookies.get(SEARCH_COUNT_COOKIE_NAME) === undefined) {
    Cookies.set(SEARCH_COUNT_COOKIE_NAME, 1, { expires: SEARCH_COUNT_EXPIRES })
  } else {
    Cookies.set(SEARCH_COUNT_COOKIE_NAME, Number(Cookies.get(SEARCH_COUNT_COOKIE_NAME)) + 1, { expires: SEARCH_COUNT_EXPIRES })
  }
}

const getSearchCountCookie = () => {
  if (Cookies.get(SEARCH_COUNT_COOKIE_NAME) === undefined) {
    return 0;
  } else {
    return Number(Cookies.get(SEARCH_COUNT_COOKIE_NAME));
  }
}

export const isOverSearchCount = () => {
  return getSearchCountCookie() > MAX_SEARCH_COUNT;
}